import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getRequestInfo } from "../../actions/inquires";

import BooleanRadio from "./BooleanRadio";
import BooleanButton from "./BooleanButton";

class ClassRequestInformation extends Component {
  constructor(props) {
    super(props);
    this.handleCheckChange = this.handleCheckChange.bind(this);
  }
  handleCheckChange(value, name) {
    this.props.getRequestInfo(this.props.inquires.home.type, value, name);
  }
  render() {
    return (
      <div  className="halfContent-inr">
        <div className="pageFormTitle fontBold colorBlack">
          Je souhaite réaliser mon rendez-vous :
        </div>
        <div className="pageFormSub">
          <BooleanRadio
            name="appointment"
            txt="Par téléphone"
            state={this.props.inquires.demande.appointment}
            value="telephone"
            onClick={this.handleCheckChange}
          />
          <BooleanRadio
            name="appointment"
            txt="Chez mon distributeur "
            state={this.props.inquires.demande.appointment}
            value="concession"
            onClick={this.handleCheckChange}
          />
        </div>
        {this.props.inquires.demande.appointment === "concession" ? (
          <div>
            <div className="pageFormTitle fontBold colorBlack">
              Voulez-vous essayer un véhicule ? *
            </div>
            <div className="pageFormSub">
              <BooleanRadio
                name="test"
                txt="Oui"
                state={this.props.inquires.demande.test}
                value="oui"
                onClick={this.handleCheckChange}
              />
              <BooleanRadio
                name="test"
                txt="Non"
                state={this.props.inquires.demande.test}
                value="non"
                onClick={this.handleCheckChange}
              />
            </div>
          </div>
        ) : null}
        <div className="pageFormTitle fontBold colorBlack">
          Précisez votre demande (optionnel) :
        </div>
        <div className="pageFormSub">
        <textarea onChange={(e) => this.handleCheckChange(e.target.value , 'comment')} className="fontMedium pageFormTxtArea fontBook colorBlack" maxLength="280" placeholder="Précisez votre demande (280 caractères maximum)...">
        </textarea>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getRequestInfo,
    },
    dispatch
  );

export const RequestInformation = connect(
  mapStateToProps,
  mapDispatchToProps
)(ClassRequestInformation);



// WEBPACK FOOTER //
// ./src/containers/components/RequestInformation.js